.backdrop { position: fixed; inset: 0; z-index: 100; background: rgba(15,18,28,.35); display: flex; justify-content: flex-end; }
.drawer {
  background: #fff; width: calc(100% - 376px); min-width: 720px; height: 100%;
  display: flex; flex-direction: column; box-shadow: -12px 0 40px rgba(0,0,0,.18);
}
.head {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding: 16px 24px; flex-shrink: 0;
}
.headLeft { display: flex; align-items: center; gap: 12px; }
.headLabel { font-size: 13px; color: var(--text-value); }
.tag {
  padding: 5px 10px; border-radius: 6px; background: #f1f2f4;
  font-size: 12px; font-weight: 500; color: var(--text-title); white-space: nowrap;
}
.close { width: 28px; height: 28px; border-radius: 6px; font-size: 18px; color: var(--text-value); }
.close:hover { background: var(--bg-table-header); }

.tabs { display: flex; gap: 28px; padding: 0 24px; border-bottom: 1px solid #e6e8ec; flex-shrink: 0; }
.tab { padding: 10px 0 12px; font-size: 14px; color: var(--text-muted); border-bottom: 2px solid transparent; }
.tab.active { color: var(--text-title); font-weight: 600; border-bottom-color: #2f6feb; }

.controls { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 14px 24px 0; flex-shrink: 0; }
.pillGroup { display: inline-flex; padding: 3px; background: #f4f5f7; border-radius: var(--radius-pill); }
.pill { padding: 4px 14px; border-radius: var(--radius-pill); font-size: 13px; color: var(--text-value); }
.pill.active { background: #e8f0fe; color: #2f6feb; font-weight: 600; }

.vizToggle { display: flex; align-items: center; gap: 10px; font-size: 12px; color: var(--text-muted); }
.vizBtns { display: inline-flex; border: 1px solid var(--border-control); border-radius: 6px; overflow: hidden; }
.vizBtn { width: 30px; height: 26px; display: inline-flex; align-items: center; justify-content: center; color: var(--text-muted); }
.vizBtn.active { background: #e8f0fe; color: #2f6feb; }

.metrics { display: flex; gap: 10px; overflow-x: auto; padding: 14px 24px 4px; flex-shrink: 0; }
.metric {
  display: flex; flex-direction: column; gap: 2px; align-items: flex-start;
  padding: 8px 12px; border: 1px solid var(--border-control); border-radius: 8px;
  background: #fff; white-space: nowrap; flex-shrink: 0; min-width: 104px;
}
.metric:disabled { opacity: .45; cursor: not-allowed; }
.metric.on { border-width: 1.5px; }
.metricTop { display: flex; align-items: center; gap: 7px; font-size: 12px; font-weight: 500; color: var(--text-title); }
.box { width: 13px; height: 13px; border-radius: 3px; border: 1.5px solid #c7ccd4; display: inline-flex; align-items: center; justify-content: center; font-size: 9px; color: #fff; }
.metricVal { font-size: 13px; font-weight: 600; color: var(--text-title); }
.metricSub { font-size: 10px; color: var(--text-muted); }

.panel { flex: 1 0 0; overflow: auto; padding: 12px 24px 24px; }
.card { border: 1px solid #eceef1; border-radius: 10px; padding: 16px; }
.cardHead { display: flex; align-items: center; justify-content: flex-end; gap: 12px; margin-bottom: 8px; }
.ranges { display: inline-flex; gap: 6px; }
.range { padding: 5px 12px; border: 1px solid var(--border-control); border-radius: 6px; font-size: 12px; color: var(--text-value); }
.range.active { border-color: #2f6feb; color: #2f6feb; font-weight: 600; }
.step { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; color: var(--text-muted); }

.state { padding: 56px 0; text-align: center; font-size: 13px; color: var(--text-muted); }
.note { margin-top: 10px; font-size: 11px; color: var(--text-muted); }
